import {StoreNamespace} from '@/globals/StoreNamespaceGlobal'
import {OnRequestorCallback, ServiceApi, Utils} from '@payroll/optimus-common';
import $ from 'jquery'
import Vue from 'vue'
import Component from 'vue-class-component'
import {Watch} from 'vue-property-decorator'
import {Getter, Mutation} from 'vuex-class'

@Component({})
export default class BaseComponent extends Vue implements OnRequestorCallback {

  @Getter('accessToken', StoreNamespace.AUTHORIZATION) accessToken!: string
  @Getter('refreshToken', StoreNamespace.AUTHORIZATION) refreshToken!: string
  @Getter('clientErrorIndication', StoreNamespace.AUTHENTICATION) clientErrorIndication!: string

  @Mutation('setAccessToken', StoreNamespace.AUTHORIZATION) setAccessToken: any
  @Mutation('setRefreshToken', StoreNamespace.AUTHORIZATION) setRefreshToken: any

  protected loading: boolean = false
  protected hasFeedback: boolean = false
  protected serverErrorMessages: string[] = []

  mounted() {
    $('body').addClass('' + this.$options.name)
  }

  beforeDestroy() {
    $('body').removeClass('' + this.$options.name)
  }

  @Watch('$route')
  onRouteChanged(newVal: any, oldVal: any) {
    this.serverErrorMessages = []
  }


  // errorCaptured(err: Error, vm: any, info: any) {
  //   console.error(`Error in ${vm.$options.name}: ${err.toString()}\nInfo: ${info}`);
  //
  //   const trace: string = err.stack ? err.stack : ""
  //
  //   if (this.clientErrorIndication) {
  //     new ServiceApi()
  //       .setToken(this.accessToken)
  //       .setRequestName('clientError')
  //       .setRequestBody({
  //         errorComponent: vm.$options.name,
  //         errorLifecycleInfo: info,
  //         errorTraceMessage: trace
  //       })
  //       .post(this);
  //   }
  //
  //   return false;
  // }

  onProgress(requestName?: string): void {
    this.loading = true
    this.$Progress.start()
  }

  onSuccess<T>(data?: T, requestName?: string, message?: string): void
  onSuccess<T>(data?: T[], requestName?: string, message?: string): void
  onSuccess(data?: any, requestName?: string, message?: string, success?: boolean): void {
  }

  onError(messages: string[], code: number, requestName?: string): void {
    this.handleOnError(messages, code, requestName);

  }

  protected handleOnError( messages: string[], code: number,  requestName?: string): void {

    switch (code) {
      case 99:
        this.handleError(messages, true)
        break
      case 400:
        this.handleError(messages, true)
        break
      case 500:
        this.handleError(messages, true)
        break
      case 401:
      case 403:
        this.handleError(messages, false, 'session-timeout')
        break
      case 404:
        this.handleError(messages, false, 'not-found')
        break
      case 503:
        this.handleError(messages, false, 'maintenance')
        break
      default:
        this.handleError(messages, false)
    }
  }

  protected handleError(messages: string[], showFeedback: boolean, errorPage?: string) {
    if (showFeedback && this.hasFeedback) {
      this.serverErrorMessages = messages || []
    } else if (messages && messages.length > 0 && messages[0]) {
      this.$root.$emit('showAlertNotification', {
        toShow: true,
        message: messages[0],
        icon: 'warning',
        secondsToDisappear: 5
      })
    } else {
      let errorMessage: string = (messages && process.env.NODE_ENV === 'development') ? messages[0] : ''
      this.$router.push({name: errorPage || 'error', params: {errorMessage: errorMessage}})
    }
    this.$emit('failedExport')
    this.$emit('failedResults')
  }

  protected sendToSentry(requestName?: string, error?: any) {
    // if (process.env.NODE_ENV === 'production') {
    //     let message: string = error ? ': ' + error : ''
    //     Sentry.captureException("Error in requestor callback for WS '" + requestName + "'" + message)
    // }
  }

  onProgressFinished(success: boolean): void {
    if (this.hasFeedback) {
      this.serverErrorMessages = []
    }
    this.loading = false;
    if (success) {
      this.$Progress.finish()
    } else {
      this.$Progress.fail()
    }
  }

  onClientError(requestName: string, ex: any): void {
    this.sendToSentry(requestName, ex)
  }

  cleanServerErrorMessages(): any {
    this.serverErrorMessages = []
  }

  onSetAccessToken(token: string): void {
    this.setAccessToken(token)
  }

  onSetRefreshToken(token: string): void {
    this.setRefreshToken(token)
  }

  onGetRefreshToken(): string {
    return this.refreshToken
  }


  get isMobile(): boolean {
    return Utils.isMobile()
  }

  get isLaptop(): boolean {
    return Utils.isLaptop()
  }

  get isTablet(): boolean {
    return Utils.isTablet()
  }
}
